import { SituacaoUsina } from "./types";

export const SITUACAO_USINA_OPTIONS: ReadonlyArray<{
  value: SituacaoUsina;
  label: string;
}> = [
  { value: "NOVA", label: "Nova usina" },
  { value: "EXISTENTE", label: "Usina existente" },
  { value: "EXPANSAO", label: "Expansão de usina" },
  { value: "USINA_CONSORCIO", label: "Usina por consórcio" },
];

/** Campos numéricos da usina que a situação esconde do formulário. */
export type CampoUsinaOcultavel =
  | "geracao"
  | "simultaneidade"
  | "custoProjeto"
  | "demandaUsina"
  | "potenciaUsina";

/** Subconjunto de CampoUsinaOcultavel que existe no payload de simulação. */
export type CampoPayloadOcultavel = Exclude<
  CampoUsinaOcultavel,
  "potenciaUsina"
>;

export const CAMPOS_OCULTOS_POR_SITUACAO: Record<
  SituacaoUsina,
  readonly CampoUsinaOcultavel[]
> = {
  NOVA: [],
  EXISTENTE: ["geracao", "simultaneidade", "custoProjeto"],
  EXPANSAO: [],
  USINA_CONSORCIO: [
    "geracao",
    "simultaneidade",
    "custoProjeto",
    "demandaUsina",
    "potenciaUsina",
  ],
};

/**
 * Espelha CAMPOS_OCULTOS_POR_SITUACAO menos `potenciaUsina`, que só vive no
 * formulário e no histórico. Esconder um campo mantendo o valor no payload
 * mudaria o cálculo do backend, então ocultar e omitir andam juntos.
 *
 * O teste `situacaoUsina.test.ts` trava os dois mapas em sincronia.
 */
export const CAMPOS_OMITIDOS_DO_PAYLOAD: Record<
  SituacaoUsina,
  readonly CampoPayloadOcultavel[]
> = {
  NOVA: [],
  EXISTENTE: ["geracao", "simultaneidade", "custoProjeto"],
  EXPANSAO: [],
  USINA_CONSORCIO: [
    "geracao",
    "simultaneidade",
    "custoProjeto",
    "demandaUsina",
  ],
};

export const ocultaCampo = (
  situacao: SituacaoUsina,
  campo: CampoUsinaOcultavel
): boolean => CAMPOS_OCULTOS_POR_SITUACAO[situacao].includes(campo);

/** Situações que exigem arquivo de medição quando há bateria. */
export const EXIGE_MEDICAO: readonly SituacaoUsina[] = [
  "EXISTENTE",
  "EXPANSAO",
];

export const labelGeracao = (situacao: SituacaoUsina): string =>
  situacao === "EXPANSAO"
    ? "Geração total adicional da expansão"
    : "Geração total da nova usina";

export const labelDemandaUsina = (situacao: SituacaoUsina): string =>
  situacao === "EXPANSAO"
    ? "Demanda total após a expansão"
    : "Demanda da usina";
